import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class EnceService {

    public infoClient: any;

    constructor(){
        this.infoClient = JSON.parse(localStorage.getItem('infoClient'))
    }

    public formatScoreClient(score:any):any{
        let result;
        if(this.infoClient.category.id == '4'){
            result = parseInt(score) * 100;
        }else if(this.infoClient.category.id == '2'){
            result = parseInt(score) / 7.8;
            result = result.toFixed(2);
        }else{
            result = score;
        }
        return result;
    }

}